import React from 'react';
import TitleAbout from "../../components/Title";
import Photo from './pictures/servicos.jpeg';
import Services from '../../components/Services';
import Ouvidoria from '../../components/Ouvidoria';

import './services.scss';
import SEO from '../../SEO/SEO';

export default function Servicos(){

  return(
    <>
    <SEO title='Serviços - Séculos Engenharia e Serviços LTDA' link='https://seculosengenharia.com.br/servicos'/>
      <div>
        <TitleAbout name="Serviços" link1={"Home / "} link2="Serviços"></TitleAbout>

      {/* section services */}
        <section id='service'>
          <div>
            <div className='service'>
              <div className='desc-service'
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0">
                <h3>
                    Soluções inteligentes e eficientes para o seu projeto
                </h3>
                <p>Com anos de experiência no mercado e uma equipe de profissionais altamente qualificada, a nossa empresa é capaz de entregar resultados eficientes e de qualidade em todas as etapas dos seus projetos. Desde a concepção até a execução, trabalhamos com os mais altos padrões de excelência e segurança, garantindo a satisfação dos nossos clientes.</p>
                <p>
                Seja qual for a sua demanda, estamos prontos para oferecer a melhor solução para o seu projeto, com foco na qualidade, eficiência e sustentabilidade.</p>
              </div>
              <div className='desc-service'>
                <img className='img-fluid' src={Photo} width="650" alt="img-about-enterprise"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                />
              </div>
            </div>
          </div>
        </section>

        <Services/>

        <Ouvidoria/>
      </div>
    </>
  )
}